import { render, staticRenderFns } from "./mProductDetail.vue?vue&type=template&id=27251f34&scoped=true"
import script from "./mProductDetail.vue?vue&type=script&lang=js"
export * from "./mProductDetail.vue?vue&type=script&lang=js"
import style0 from "./mProductDetail.vue?vue&type=style&index=0&id=27251f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27251f34",
  null
  
)

export default component.exports